module.exports = __webpack_public_path__ + "img/IMG_2100.20952a5d.jpg";